import script from "./Client.vue?vue&type=script&setup=true&lang=js"
export * from "./Client.vue?vue&type=script&setup=true&lang=js"

import "./Client.vue?vue&type=style&index=0&id=63b82f90&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b82f90"]])

export default __exports__